import script from "./RefundArriveUpdate.vue?vue&type=script&setup=true&lang=js"
export * from "./RefundArriveUpdate.vue?vue&type=script&setup=true&lang=js"

import "./RefundArriveUpdate.vue?vue&type=style&index=0&id=6f9ccfaa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f9ccfaa"]])

export default __exports__